// TODO: remove once QA/prod .env values are wrapped in quotes (dotenv strips
// trailing `#` on unquoted values, treating it as an inline comment).
const raw = String(import.meta.env.VITE_ENCRYPT_KEY ?? '');
export const keyEnpt = raw.endsWith('#') ? raw : `${raw}#`;
